<template>
  <div class="pb-16">
    <div class="z-20 w-full fixed top-0">
      <MerchantNav :disable-hide-on-scroll="true" />
    </div>

    <div class="h-24">
      <!-- spacer -->
    </div>

    <div class="px-4 py-8">
      <div v-if="loading" class="text-center py-4">Loading franchise data...</div>
      <div v-else-if="franchiseData" class="max-w-lg lg:max-w-xl mx-auto">
        <div class="md:mx-0 flex gap-y-3 flex-wrap justify-between">
          <div
            v-fade-in
            v-for="location in franchiseData.data.attributes.locations"
            :key="location.location_description"
            class="w-full"
          >
            <div class="relative bg-white w-full rounded-lg border overflow-hidden" :class="cardShadowClasses">
              <!-- Location Header -->
              <div class="bg-white px-6 py-4 flex flex-col justify-between w-full">
                <div class="flex justify-between items-center w-full">
                  <div class="flex justify-start space-x-2 items-center">
                    <p class="font-bold text-xl leading-5 tracking-tighter">
                      {{ location.location_description }}
                    </p>
                  </div>
                </div>
                <div class="mt-2">
                  <p v-if="location.profile_description" class="text-sm text-gray-500">
                    {{ location.profile_description }}
                  </p>
                  <p class="text-sm text-gray-600 mt-2 pt-2">
                    {{ location.city }}, {{ location.state }} {{ location.zip }}
                  </p>
                </div>
              </div>

              <!-- Stores Section -->
              <div v-if="location.stores && location.stores.length > 0" class="border-t border-gray-brand-300">
                <a
                  v-for="store in location.stores"
                  :key="store.id"
                  :href="storeHref(store)"
                  class="block w-full bg-white px-6 py-4 flex flex-col justify-between cursor-pointer border-b border-gray-brand-300 last:border-b-0"
                  @click.prevent="goToStore(store)"
                >
                  <div class="flex justify-between items-center w-full">
                    <div class="flex justify-start space-x-2 items-center">
                      <p class="font-bold text-xl leading-5 tracking-tighter">
                        {{ store.name }}
                      </p>
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </div>
                  </div>
                </a>
              </div>

              <!-- No Stores Message -->
              <div v-else class="border-t border-gray-brand-300 px-6 py-4">
                <p class="text-sm text-gray-500 text-center">No stores available at this location</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MerchantNav } from '@/components'
import { cardShadowClasses } from '@/config'
import merchantFetch from '@/utils/merchantFetch'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'FranchiseStores',
  components: { MerchantNav },
  setup() {
    const router = useRouter()
    const store = useStore()
    const franchiseData = ref(null)
    const loading = ref(true)

    onMounted(async () => {
      try {
        const response = await merchantFetch('franchise')
        franchiseData.value = response
      } catch (error) {
        console.error('Error fetching franchise data:', error)
      } finally {
        loading.value = false
      }
    })

    const storeRoute = (storeData) => ({
      name: 'BottleFactory',
      params: { storeSlug: storeData.slug, storeId: storeData.id }
    })

    const storeHref = (storeData) => router.resolve(storeRoute(storeData)).href

    const goToStore = async (storeData) => {
      // Set the selectedStoreSlug in the store
      store.commit('SET_SELECTED_STORE_SLUG', storeData.slug)

      console.log('Starting getToken...')

      await store.dispatch('getToken', {
        subdomain: window.location.host,
        store_slug: storeData.slug
      })
      router.push(storeRoute(storeData))
    }

    return {
      cardShadowClasses,
      franchiseData,
      loading,
      goToStore,
      storeHref
    }
  }
}
</script>
